export const ApiConfigData = {
    //api_endpoint: 'http://elocky-dev.develo.ovh'
    api_endpoint: 'https://elocky.com' 
}
